import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { useLocation, useNavigate } from 'react-router-dom'
import { goToLink } from '../../projectData'
import { handlePincodeChange } from '../../../component/pincode'
import { getPincodeDetail } from '../../../company-module/api'



/**
 * editUserSchema
 * Yup validation schema for editing user address fields.
 */
const editUserSchema = Yup.object().shape({
    pincode: Yup.number().required('Pincode is required'),
    city: Yup.string().trim().required('A  city is required .'),
    state: Yup.string().trim().required('A  state is required'),
    district: Yup.string().trim().required('A  district is required'),
    address1: Yup.string().trim().required('Address is required'),
    address2: Yup.string().trim().required('Address is required'),
    // address3: Yup.string().required('Address is required'),
    landmark: Yup.string().trim().required('landmark is required'),
})

/**
 * UpdateRedemAddress
 * Renders the address update form for redemption, handles validation and submission.
 */
export const UpdateRedemAddress = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const orders = location.state.orders;
    const addressData = location.state?.address
    const token = location.state?.token
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...addressData,
            address1: addressData?.address1 || '',
            address2: addressData?.address2 || '',
            address3: addressData?.address3 || '',
            landmark: addressData?.landmark || '',
            city: addressData?.city || '',
            state: addressData?.state || '',
            district: addressData?.district || '',
            pincode: addressData?.pincode || '',
            address_id: addressData?.address_id,
            redemption_id: addressData?.redemption_id,
            request_token: token,
            address_status_id: 1

        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            goToLink(navigate, '/customer/address/re-confirm', { orders: orders, address: values, token: token })
        },
    })

    return (<>
        <div className="px-3">
            <div className='card p-2 ps-4 mt-4' style={{ backgroundColor: "#FBF6F7", border: "0.5px solid #f2f2f2" }}>
                <div className='fs-6 fw-semibold'>
                    Update your address.
                </div>
                <div className='fs-6 fw-normal mt-1'>Fields marked in <span className='text-danger'>*</span>  are mandatory to fill</div>
            </div>
            <form id="kt_form" className="form fv-plugins-bootstrap5 fv-plugins-framework mt-4"
                onSubmit={formik.handleSubmit} noValidate>
                <div className="card">
                    <div className="card-body p-0">
                        <div className=" py-1">
                            <label className=" required fw-semibold fs-6 mb-1"> House/Shop No.</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter Flat, House No, Building, Apartment*"
                                    {...formik.getFieldProps('address1')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='address1'
                                    className={clsx(
                                        'form-control form-control-md    form-control-solid',
                                        { 'is-invalid': formik.touched.address1 && formik.errors.address1 },
                                        { 'is-valid': formik.touched.address1 && !formik.errors.address1, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.address1 && formik.errors.address1 ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.address1}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className=" py-1">

                            <label className=" required fw-semibold fs-6 mb-1"> Sector/ Village</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter Street, Sector, Village"
                                    {...formik.getFieldProps('address2')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='address2'
                                    className={clsx(
                                        'form-control form-control-md  form-control-solid',
                                        { 'is-invalid': formik.touched.address2 && formik.errors.address2 },
                                        { 'is-valid': formik.touched.address2 && !formik.errors.address2, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />

                                {formik.touched.address2 && formik.errors.address2 ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.address2}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className=" py-1">

                            <label className="   fw-semibold fs-6 mb-1">Area</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter Area"
                                    {...formik.getFieldProps('address3')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='address3'
                                    className={clsx(
                                        'form-control form-control-md    form-control-solid',
                                        { 'is-invalid': formik.touched.address3 && formik.errors.address3 },
                                        { 'is-valid': formik.touched.address3 && !formik.errors.address3, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.address3 && formik.errors.address3 ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.address3}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className=" py-1">

                            <label className="  fw-semibold fs-6 mb-1">Landmark</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter Landmark"
                                    {...formik.getFieldProps('landmark')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='landmark'
                                    className={clsx(
                                        'form-control form-control-md   form-control-solid',
                                        { 'is-invalid': formik.touched.landmark && formik.errors.landmark },
                                        { 'is-valid': formik.touched.landmark && !formik.errors.landmark, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.landmark && formik.errors.landmark ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.landmark}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className=" py-1">

                            <label className=" required fw-semibold fs-6 mb-1">City</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter City"
                                    {...formik.getFieldProps('city')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='city'
                                    className={clsx(
                                        'form-control form-control-md   form-control-solid',
                                        { 'is-invalid': formik.touched.city && formik.errors.city },
                                        { 'is-valid': formik.touched.city && !formik.errors.city, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.city && formik.errors.city ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.city}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className=" py-1">

                            <label className=" required fw-semibold fs-6 mb-1">Pincode</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <div className="input-group mb-3">
                                    <input
                                        placeholder="Enter Pincode"
                                        {...formik.getFieldProps('pincode')}
                                        type="text"
                                        onChange={(e) => handlePincodeChange(formik, getPincodeDetail, e)}
                                        name="pincode"
                                        className={clsx(
                                            'form-control form-control-md   form-control-solid',
                                            { 'is-invalid': formik.touched.state && formik.errors.state },
                                            { 'is-valid': formik.touched.state && !formik.errors.state, }
                                        )}
                                        autoComplete="off"
                                        disabled={formik.isSubmitting}
                                    />
                                </div>
                                {formik.values.pincode_reponse &&
                                    <div className={formik.values.pincode_reponse === "success" ? "text-success" : "text-danger"}>{formik.values.pincode_reponse}</div>
                                }
                                {formik.touched.pincode && formik.errors.pincode ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.pincode}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>

                        </div>
                        <div className="py-1">
                            <label className="required fw-semibold fs-6 mb-1">District</label>
                            <div className="fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter District"
                                    {...formik.getFieldProps('district')}
                                    type="text"
                                    onChange={formik.handleChange}
                                    name="district"
                                    className={clsx(
                                        'form-control form-control-md form-control-solid',
                                        { 'is-invalid': formik.touched.district && formik.errors.district },
                                        { 'is-valid': formik.touched.district && !formik.errors.district }
                                    )}
                                    autoComplete="off"
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.district && formik.errors.district ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            <span className="text-danger" role="alert">{formik.errors.district}</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-muted fs-7"></div>
                                )}
                            </div>
                        </div>

                        <div className=" py-1">
                            <label className=" required fw-semibold fs-6 mb-1">State</label>
                            <div className=" fv-row fv-plugins-icon-container">
                                <input
                                    placeholder="Enter State"
                                    {...formik.getFieldProps('state')}
                                    type='text'
                                    onChange={formik.handleChange}
                                    name='state'
                                    className={clsx(
                                        'form-control form-control-md    form-control-solid',
                                        { 'is-invalid': formik.touched.state && formik.errors.state },
                                        { 'is-valid': formik.touched.state && !formik.errors.state, }
                                    )}
                                    autoComplete='off'
                                    disabled={formik.isSubmitting}
                                />
                                {formik.touched.state && formik.errors.state ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.state}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>
                        </div>


                    </div>

                    <div className="d-flex justify-content-between py-4">
                        <button type="button" onClick={() => navigate(-1)} id="kt_ecommerce_add_Company_submit" className="btn btn-dark me-2 w-50"
                        // disabled={formik.isSubmitting || !formik.isValid}
                        >
                            <span className="indicator-label">Cancel</span>
                            {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                        </button>
                        <button type="submit" id="kt_ecommerce_add_Company_submit" className="btn btn-primary w-50"
                        // disabled={formik.isSubmitting || !formik.isValid}
                        >
                            <span className="indicator-label"> Update  </span>

                        </button>
                    </div>

                </div>
            </form>
        </div>

    </>
    )
}